import { render } from "./WhiteGloveView.vue?vue&type=template&id=70395544&scoped=true"
import script from "./WhiteGloveView.vue?vue&type=script&lang=js"
export * from "./WhiteGloveView.vue?vue&type=script&lang=js"

import "./WhiteGloveView.vue?vue&type=style&index=0&id=70395544&scoped=true&lang=css"

import exportComponent from "/Users/chrisfinlayson/Desktop/WORK/riverhawk-nest/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70395544"]])

export default __exports__